import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=395bd932&scoped=true"
import script from "./baseInfo.vue?vue&type=script&lang=js"
export * from "./baseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395bd932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395bd932')) {
      api.createRecord('395bd932', component.options)
    } else {
      api.reload('395bd932', component.options)
    }
    module.hot.accept("./baseInfo.vue?vue&type=template&id=395bd932&scoped=true", function () {
      api.rerender('395bd932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/baseInfo.vue"
export default component.exports